import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PageDirective } from './page.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PageDirective],
  exports: [PageDirective],
})
export class PageModule {}
